import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../Context/AuthProvider";
import { useEffect } from "react";
import axios from "axios";
import { url } from "../../../Constant";
import { useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import { checkIndividualPermission } from "../../../Utils/PermissionFunctions";

const EditQueue = () => {
  const location = useLocation();
  if (location.state === null) {
    window.location.href = "/queue";
  }
  const { auth } = useAuth();
  const [selectedExtensions, setSelectedExtensions] = useState([]);
  const [submittedData, setSubmittedData] = useState({
    queue_name: "",
    queue_type: "",
    sip_id: "",
  });
  const [extensionNumbers, setExtensionNumbers] = useState([]);

  const queueTypes = [
    {
      name: "Ring all",
      value: "ring_all",
    },
    {
      name: "Sequence",
      value: "sequence",
    },
    {
      name: "Priority",
      value: "priority",
    },
    // {
    //   name: "Routing",
    //   value: "routing",
    // },
  ];
  const [errorEnable, setErrorEnable] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (location.state !== null) {
      const newArray = extensionNumbers.filter((obj) =>
        location.state.sip_id.includes(obj.label)
      );
      let array = Array.isArray(newArray) ? newArray.map((x) => x.value) : null;

      setSubmittedData({
        sip_id: String(array),
        queue_name: location?.state?.queue_name,
        queue_type: location?.state?.queue_type,
      });
      setSelectedExtensions(newArray);
    }
  }, [extensionNumbers]);

  const handleSelect = (e) => {
    let array = Array.isArray(e) ? e.map((x) => x.value) : null;
    setSelectedExtensions(e);
    setSubmittedData({
      ...submittedData,
      sip_id: String(array),
    });
  };

  const getCallPrompt = () => {
    let api = "";
    if (auth.role === "2") {
      api = "get-queue-extensions";
    } else {
      api = "user-get-queue-extensions";
    }

    axios
      .post(
        url + api,
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then(
        (response) => {
          if (response.data.status === true) {
            let optionsForMultiSelect = [];
            response.data.data.map((val) => {
              optionsForMultiSelect.push({
                value: val.id,
                label: val.username,
              });
            });

            setExtensionNumbers(optionsForMultiSelect);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  useEffect(() => {
    if (
      auth.role === "1" ||
      (auth.role === "3" &&
        !checkIndividualPermission("queue", "read_and_write"))
    ) {
      window.location.href = "/";
    }
    getCallPrompt();
  }, []);

  const editQueue = () => {
    setErrorEnable(true);
    setLoader(true);
    let data = {
      sip_id: submittedData.sip_id,
      queue_name: submittedData.queue_name,
      queue_type: submittedData.queue_type,
      queue_id: location.state.queue_id,
      vpbx_id: location.state.vpbx_id,
    };
    if (
      submittedData.queue_name !== "" &&
      submittedData.queue_type !== "" &&
      submittedData.sip_id !== ""
    ) {
      let api = "";
      if (auth.role === "2") {
        api = "update-queue";
      } else {
        api = "user-update-queue";
      }

      axios
        .post(url + api, data, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.data.code === 200) {
              setLoader(false);
              toast.success("Queue Updated Successfully", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
              setTimeout(() => {
                window.location.href = "/queue";
              }, 2000);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div>
      <div className="dashboardWrp">
        <div className="uk-container uk-container-small">
          <div className="dashboardTop">
            <div uk-grid="" className="uk-grid uk-grid-small">
              <div className="uk-width-2-3">
                <div className="dashboardIntro">
                  <Link to="/queue">
                    <img
                      src="./assets/images/zong/chevron--left.svg"
                      uk-svg=""
                    />
                    <span>Back to VPBX manager</span>
                  </Link>
                  <h3>Edit Queue</h3>
                  {/* <p>
                    Create a new call routing by selecting the desired
                    department and assigning extensions in your preferred
                    sequence.
                  </p> */}
                </div>
              </div>
            </div>

            <form action="javascript:void(0);">
              <div className="formCreateMain">
                <div className="uk-grid uk-grid-small">
                  <div className="uk-width-1-1@m uk-margin-top">
                    <legend className="uk-legend">Edit Queue Settings</legend>
                  </div>
                  <div className="uk-width-1-2@m uk-margin-top">
                    <label>Queue name</label>
                    <input
                      className="uk-input"
                      type="text"
                      aria-label="Input"
                      placeholder="Enter queue name"
                      value={submittedData?.queue_name}
                      onChange={(e) => {
                        setSubmittedData({
                          ...submittedData,
                          queue_name: e.target.value,
                        });
                      }}
                    />
                    {errorEnable && submittedData.queue_name === "" && (
                      <div className="formErrors">Queue name is required</div>
                    )}
                  </div>
                  <div className="uk-width-1-2@m uk-margin-top">
                    <label>Queue</label>
                    <Select
                      isMulti
                      value={selectedExtensions}
                      name="agents"
                      options={extensionNumbers}
                      // value={layers[indexParent][`option${index + 1}`].split(",")}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      onChange={(e) => handleSelect(e)}
                    />
                    {errorEnable && submittedData.queue_name === "" && (
                      <div className="formErrors">Queue is required</div>
                    )}
                  </div>
                  <div className="uk-width-1-2@m uk-margin-top">
                    <label>Queue type</label>
                    <select
                      className="uk-select"
                      aria-label="Select"
                      value={submittedData?.queue_type}
                      onChange={(e) =>
                        setSubmittedData({
                          ...submittedData,
                          queue_type: e.target.value,
                        })
                      }
                      //   selected={
                      //     submittedData.queue_type===
                      //   }
                    >
                      <option value="" selected disabled hidden>
                        Select a queue type
                      </option>
                      {queueTypes?.map((val, index) => {
                        return (
                          <option key={index} value={val.value}>
                            {val.name}
                          </option>
                        );
                      })}
                    </select>
                    {errorEnable && submittedData.queue_type === "" && (
                      <div className="formErrors">Queue type is required</div>
                    )}
                  </div>

                  <div className="uk-width-1-1@m uk-float-right">
                    <div className="formActionBtn uk-text-right">
                      {/* <button className="whiteBtn">Cancel</button> */}
                      <button className="pinkBtn" onClick={editQueue}>
                        {loader ? (
                          <div uk-spinner="" className="loader">
                            Adding
                          </div>
                        ) : (
                          "Update"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditQueue;
